export default "__VITE_ASSET__B0z8GDEa__"